/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.9193 5.1429C6.9193 2.3025 9.194 0 12 0c2.7154 0 4.9333 2.1564 5.0736 4.8697l.007.2732v3.0857h1.6936c1.9815 0 3.6017 1.5657 3.719 3.5417L22.5 12v8.2286C22.5 22.3115 20.8319 24 18.7742 24H5.2258C3.1681 24 1.5 22.3115 1.5 20.2286V12c0-2.0829 1.6681-3.7714 3.7258-3.7714h1.6936V5.1429Zm6.0972 8.7471-.0004-1.2043-.0092-.1396a1.0296 1.0296 0 0 0-.5146-.7604A1.002 1.002 0 0 0 12 11.6571a1.002 1.002 0 0 0-.4923.1286 1.0304 1.0304 0 0 0-.5238.9l.001 1.2038c-1.1845.4233-2.0333 1.5666-2.0333 2.9105 0 1.7042 1.3648 3.0857 3.0484 3.0857s3.0484-1.3815 3.0484-3.0857c0-1.3434-.8481-2.4863-2.0319-2.91Zm-7.7907-3.6043c-.9353 0-1.6935.7675-1.6935 1.7143v8.2286c0 .9467.7582 1.7143 1.6935 1.7143h13.5484c.9353 0 1.6935-.7676 1.6935-1.7143V12c0-.9468-.7582-1.7143-1.6935-1.7143H5.2258Zm7.2581 2.4s0 .0001 0 0Zm-.5185 0h.5185v-.0013l-.5121.0005M8.9516 8.2286V5.1429l.007-.2113C9.066 3.3259 10.3866 2.057 12 2.057c1.6836 0 3.0484 1.3816 3.0484 3.0858v3.0857H8.9516ZM10.984 16.8c0-.5681.4549-1.0286 1.0161-1.0286.5612 0 1.0161.4605 1.0161 1.0286 0 .5681-.4549 1.0286-1.0161 1.0286-.5612 0-1.0161-.4605-1.0161-1.0286Z"
    clipRule="evenodd"
  />,
  'MenuCredentials'
);
